export const getColumns = (selectedField, handleTextChange) => {
  const columns = [
    {
      title: 'Product Name',
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {/* <div className="variantImagebox">
            <img
              src={record.image}
              alt="product"
              style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4 }}
            />
          </div> */}
          <span>{record.name}</span>
        </div>
      ),
    },
    {
      title: 'SAP SKU',
      dataIndex: 'sku',
      key: 'sku',
    },
    {
      title: 'Store',
      dataIndex: 'store',
      key: 'store',
    },
  ];

  if (selectedField) {
    columns.push({
      title: 'Variation Value',
      dataIndex: 'VariationValue',
      key: 'VariationValue',
      render: (_, record, index) => (
        <input
          placeholder="Please type the variation value"
          style={{ width: '100%', maxWidth:220 }}
          className="VariationInput"
          onChange={e => {
            // record.description = e.currentTarget.value
            handleTextChange(e.target.value, index);

          }}
        />
      ),
    });
  }

  return columns;
};
